import { ExtendedDataProvider } from "@src/types";

export const validateSchema = async (
    schema: string,
    dataProvider: ExtendedDataProvider
): Promise<{ success: boolean; message?: string; errors?: any }> => {
    try {
        await dataProvider.createAction('services', {
            data: JSON.parse(schema),
            verb: 'validate/'
        });
        return { success: true, message: 'Schema validation successful' };
    } catch (error: any) {
        if (error.body) {
            return { 
                success: false, 
                errors: error.body.errors || error.body,
                message: 'Schema validation failed'
            };
        }

        return { 
            success: false, 
            message: error.message || 'Schema validation failed'
        };
    }
}; 